import { useState } from "react";
import SendBulkEmail from "./SendBulkEmail";
import SendIndividualEmail from "./SendIndividualEmail";
import EmailForm from "./EmailForm";
import EmailTemplate from "./EmailTemplate";
import EmailList from "./EmailList";

const EmailDashboard = () => {
  const [activeTab, setActiveTab] = useState("list");

  const tabs = [
    { key: "list", label: "Email List" },
    { key: "form", label: "Email Form" },
    { key: "template", label: "Email Template" },
    { key: "sendBulk", label: "Send Bulk Email" },
    { key: "sendIndividual", label: "Send Individual Email" },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
      <h1 className="text-4xl font-bold text-center mb-2">Email Dashboard</h1>
      <p className="text-center text-gray-500 mb-6">
        Manage emails, send messages, and customize your email templates.
      </p>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-5 py-2 rounded-full font-medium transition ${
              activeTab === tab.key
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-gray-50 rounded-lg p-6 shadow-sm">
        {activeTab === "list" && <EmailList />}
        {activeTab === "form" && <EmailForm />}
        {activeTab === "template" && <EmailTemplate />}
        {activeTab === "sendBulk" && <SendBulkEmail />}
        {activeTab === "sendIndividual" && <SendIndividualEmail />}
      </div>
    </div>
  );
};

export default EmailDashboard;
